import { onFormValuesChange, type Form } from '@formily/core';
import { useEffect, useState } from 'react';

export const useFormilyValuesChangeIndex = (form: Form): number => {
  const [changeIndex, setChangeIndex] = useState(0);

  useEffect(() => {
    const effectId = `form-values-change-index-${crypto.randomUUID()}`;

    form.addEffects(effectId, () => {
      onFormValuesChange(() => {
        setChangeIndex(current => current + 1);
      });
    });

    return () => {
      form.removeEffects(effectId);
    };
  }, [form]);

  return changeIndex;
};
